import {fetchGetTorresowo} from "../../../utils/utils";
import {TORRESOWO_URL} from "../../../utils/consts";
import auth from "../../../utils/authentication";

export const fetchNextEpisodes = async (userId) => {
    return await fetchGetTorresowo(`/tmdb/v2/get-user-next-episodes?uid=${userId}`);
}

export const fetchNewFutureEpisodes = async (userId) => {
    return await fetchGetTorresowo(`/tmdb/v2/get-user-future-episodes?uid=${userId}`);
}

export const fetchViewLaterItems = async (userId) => {
    return await fetchGetTorresowo(`/tmdb/v2/get-view-later-items?uid=${userId}`);
}

export const fetchTmdbItemsNotes = async (userId) => {
    return await fetchGetTorresowo(`/tmdb/v2/get-items-with-notes?uid=${userId}`);
}

export const fetchTorrestreamItems = async (userId) => {
    return await fetchGetTorresowo(`/tmdb/v2/get-torrestream-items?uid=${userId}`);
}

export const fetchEpisodeGroupDetails = async (tmdbId, season, episode) => {
    return await fetchGetTorresowo(`/tmdb/group-details/${tmdbId}/${season}/${episode}`);
}

export const fetchTrendingMovies = async (page = 1) => {
    return await fetchGetTorresowo(`/tmdb/v2/get-trending-movies?page=${page}`);
}

export const fetchTrendingSeries = async (page = 1) => {
    return await fetchGetTorresowo(`/tmdb/v2/get-trending-series?page=${page}`);
}

export function fetchSquadflixAvailableItems({type, mode}) {
    let url = `/sharing/shared-${type}/1?uid=${auth.currentUser.uid}`;
    if (mode) {
        url += `&type=${mode}`;
    }
    return fetchGetTorresowo(url)
}

export function searchPage(text, page, type) {
    const urlSearch = type === 'movies' ? '/tmdb/movie-search' : '/tmdb/serie-search';
    return fetch(TORRESOWO_URL + urlSearch + `?text=${text}&page=${page}&uid=${auth.currentUser.uid}`)
        .then(res => {
            return res.json()
        }).then(data => {
            return data;
        });
}

export function fetchMovieCallback(movieId, uid) {
    const url = `/tmdb/movie/${movieId}?uid=${uid}`;

    return fetchGetTorresowo(url);
}

export function fetchSerieCallback(serieId, uid) {
    const url = `/tmdb/serie/${serieId}?uid=${uid}`;

    return fetchGetTorresowo(url);
}

export function fetchSeasonCallback(serieId, seasonNumber, uid) {
    const url = '/tmdb/serie/' + serieId + '/season/' + seasonNumber + '?uid=' + uid;

    return fetchGetTorresowo(url);
}

export function fetchEpisodeCallback(serieId, seasonNumber, episodeNumber, uid) {
    const url = '/tmdb/serie/' + serieId + '/season/' + seasonNumber + '/episode/' + episodeNumber + '?uid=' + uid;

    return fetchGetTorresowo(url);
}

export function fetchFileSquadflixDetails(shareUrl) {
    return fetchGetTorresowo(`/get-file-details/${shareUrl}`);
}

export function fetchTmdbMovieImages(tmdbId) {
    return fetchGetTorresowo(`/tmdb/v2/get-movie-images/${tmdbId}`);
}

export function fetchTmdbSerieImages(tmdbId, season, episode) {
    if (season == null && episode == null) {
        return fetchGetTorresowo(`/tmdb/v2/get-serie-images/${tmdbId}`);
    } else if (episode == null) {
        return fetchGetTorresowo(`/tmdb/v2/get-serie-images/${tmdbId}/${season}`);
    } else {
        return fetchGetTorresowo(`/tmdb/v2/get-serie-images/${tmdbId}/${season}/${episode}`);
    }
}

export function fetchTmdbMovieSuggestions(tmdbId) {
    return fetchGetTorresowo(`/tmdb/v2/get-suggestions/movie/${tmdbId}`);
}

export function fetchTmdbSerieSuggestions(tmdbId) {
    return fetchGetTorresowo(`/tmdb/v2/get-suggestions/serie/${tmdbId}`);
}

export function fetchSeasonDetails(serieId, seasonNumber, uid) {
    return fetchGetTorresowo('/tmdb/serie/' + serieId + '/season/' + seasonNumber + '?uid=' + uid);
}

export function fetchSerieDetails(serieId, uid) {
    let url = `/tmdb/serie/${serieId}`;
    if (uid) {
        url += `?uid=${uid}`;
    }
    return fetchGetTorresowo(url);
}

export function postShareSquadflixMovie(body) {
    return fetch(TORRESOWO_URL + '/sharing/share-movie', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
    }).then(res => {
        return res.json()
    });
}

export function postShareSquadflixEpisode(body) {
    return fetch(TORRESOWO_URL + '/sharing/share-episode', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
    }).then(res => {
        return res.json()
    });
}